/**
 * Render Process Steps modal body HTML for the frontend view script.
 */
import {
	escapeHtml,
	getBadgeLabel,
	renderStepperArrowHtml,
	sanitizeRichHtml,
} from './modal-utils';

/**
 * @param {string} html Rich text or plain text.
 * @return {string} Body markup.
 */
function renderBodyText( html ) {
	const sanitized = sanitizeRichHtml( html );

	if ( ! sanitized ) {
		return '';
	}

	return `<div class="alteia-pss-modal__card-body">${ sanitized }</div>`;
}

/**
 * @param {Object} step Modal step data.
 * @return {string} Modal body HTML.
 */
export function renderModalBodyHtml( step ) {
	const content = step?.modalContent || {};
	const processSteps = Array.isArray( content.processSteps )
		? content.processSteps
		: [];
	const badges = Array.isArray( content.badges ) ? content.badges : [];

	const introCards = [];

	if ( content.whatTitle || content.whatText ) {
		introCards.push( `<article class="alteia-pss-modal__card">
			${
				content.whatTitle
					? `<h3 class="alteia-pss-modal__card-title">${ escapeHtml(
							content.whatTitle
					  ) }</h3>`
					: ''
			}
			${ renderBodyText( content.whatText ) }
		</article>` );
	}

	if ( content.approachTitle || content.approachText ) {
		introCards.push( `<article class="alteia-pss-modal__card">
			${
				content.approachTitle
					? `<h3 class="alteia-pss-modal__card-title">${ escapeHtml(
							content.approachTitle
					  ) }</h3>`
					: ''
			}
			${ renderBodyText( content.approachText ) }
		</article>` );
	}

	const stepperItems = processSteps
		.filter( ( item ) => item.title || item.description )
		.map( ( item, index ) => {
			return `${
				index > 0 ? renderStepperArrowHtml() : ''
			}<article class="alteia-pss-modal__stepper-item">
				<div class="alteia-pss-modal__stepper-icon-circle">
					<span class="alteia-pss-modal__stepper-number" aria-hidden="true">${
						index + 1
					}</span>
				</div>
				<div class="alteia-pss-modal__stepper-content">
					${
						item.title
							? `<div class="alteia-pss-modal__stepper-heading">
						<h3 class="alteia-pss-modal__stepper-title">${ escapeHtml(
							item.title
						) }</h3>
					</div>`
							: ''
					}
					${
						item.description
							? `<div class="alteia-pss-modal__stepper-description">${ sanitizeRichHtml(
									item.description
							  ) }</div>`
							: ''
					}
				</div>
			</article>`;
		} );

	const badgeItems = badges
		.filter( ( badge ) => badge.label )
		.map( ( badge ) => {
			const colorStyle = badge.color
				? ` style="background-color:${ escapeHtml( badge.color ) }"`
				: '';
			return `<span class="alteia-pss-modal__badge"${ colorStyle }>${ escapeHtml(
				getBadgeLabel( badge )
			) }</span>`;
		} )
		.join( '' );

	return `<div class="alteia-pss-modal__content">
		${
			introCards.length
				? `<div class="alteia-pss-modal__intro">${ introCards.join(
						''
				  ) }</div>`
				: ''
		}
		${
			stepperItems.length
				? `<div class="alteia-pss-modal__stepper">${ stepperItems.join(
						''
				  ) }</div>`
				: ''
		}
		${
			content.whyTitle || content.whyText
				? `<article class="alteia-pss-modal__card alteia-pss-modal__card--full">
					${
						content.whyTitle
							? `<h3 class="alteia-pss-modal__card-title">${ escapeHtml(
									content.whyTitle
							  ) }</h3>`
							: ''
					}
					${ renderBodyText( content.whyText ) }
				</article>`
				: ''
		}
		${
			content.commonUsesTitle || badgeItems
				? `<article class="alteia-pss-modal__card alteia-pss-modal__card--full alteia-pss-modal__card--uses">
					${
						content.commonUsesTitle
							? `<h3 class="alteia-pss-modal__card-title">${ escapeHtml(
									content.commonUsesTitle
							  ) }</h3>`
							: ''
					}
					${
						badgeItems
							? `<div class="alteia-pss-modal__badges">${ badgeItems }</div>`
							: ''
					}
				</article>`
				: ''
		}
	</div>`;
}
